import { render } from "./Start-seite.vue?vue&type=template&id=e1171d8e&scoped=true"
import script from "./Start-seite.vue?vue&type=script&lang=js"
export * from "./Start-seite.vue?vue&type=script&lang=js"

import "./Start-seite.vue?vue&type=style&index=0&id=e1171d8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1171d8e"]])

export default __exports__